import React, { useEffect, useState } from 'react';
import LeftSection from './left-section/left-section';
import RightSection from './right-section/right-section';
import MiddleSection from './middle-section/middle-section';
import {
  Grid,
  Breadcrumbs,
  Typography,
  Link,
  CircularProgress
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HttpService from '../services/http.service';
import ModalAccept from './components/modalAccept';
import Header from '../components/header/header';
import Loader from '../components/loader/loader';
import Footer from '../components/footer/footer';
import { useNavigate } from 'react-router-dom';
import GeneralCAST from './components/generateCSAT';
import './assets/css/main.css';
import './assets/css/modal.css';
import CartType from '../models/CartType';
import LicenseModal from './components/licenseModal';
import LiveChatCountries from '../models/LiveChatCountries';

import {
  Commit,
  Accept,
  UnCommit,
  batchCommitProductMember,
  start,
  batchUncommit,
  fetchAllManifoldAssemblyStations,
  commitAssemblyManifold,
  unCommitAssemblyManifold,
  configureFromConfigState,
  configureFromBom
} from '../services/configuratorService';

import {
  getHoseAssemblyPrice,
  getPricefromLegacyPriceSheets,
  getTotalPriceforSegmentandAssembly,
  getPriceforAssemblyandSegment,
  removePriceforSegment
} from '../services/pricingService';

import { getContactInfo } from '../services/contactService';

import {
  getTranslations,
  assignTranslations
} from '../services/translationService';

import {
  getUniquePartIdentifierforManifold,
  getConfigStateByPart,
  create,
  uniqueCodeTemplate,
  getConfigStateByPartNumber,
  getByPart,
  find
} from '../services/bomService';

import {
  initialize,
  shareConfigurationDataLayer,
  partSearchDataLayer,
  copyToClipboardDataLayer,
  saveConfigurationDataLayer,
  loadConfigurationDataLayer,
  deleteConfigurationDataLayer
} from '../services/pdfDataLayer';

import ConfigOptionFeedback from './components/configOptionFeedback';
import { getQueryParam } from '../services/commonService';

import {
  currentSegmentcommitedUIMembers,
  assignEditedSegmentMember,
  getCommitsForSegment
} from '../services/cadService';
import { getManufacturingLocation } from '../services/locationService';

import {
  allSegments,
  getStep,
  getPartNumberString,
  getStepMembers
} from '../services/tactonService';

import {
  postSessionData,
  getSessionData
} from '../services/sessionDataService';

import { getChat } from '../services/chatService';

import {
  facetInteractionDataLayer,
  SetCommitsName,
  getIndex,
  RemoveCommitsName
} from '../services/facetInteractionService';

import { getProductPagePartSelection } from '../services/productPagePartSelectionService';

import { getContentSyndicationData } from '../services/contentSyndicationService';

import salesForceChat from './salesForceChat';

import shareConfigurationInfo from '../services/shareService';

const MainWrapper = props => {
  const navigate = useNavigate();
  let translations = assignTranslations(null);

  const queryParams = getQueryParam();
  const [divisionId, setDivisionId] = React.useState('');
  const [configModel, setConfigModel] = React.useState('');
  const [sessionId, setSessionId] = React.useState('');
  const [openModal, setOpenModal] = React.useState(false);
  const [modalValue, setModalValue] = React.useState({});
  const handleOpen = () => setOpenModal(true);
  const [sessionData, setSessionData] = React.useState();
  const [postSessionId, setPostSessionId] = React.useState('');
  const [contactUs, setContactUs] = React.useState({});
  const [langParameter, setLangParameter] = React.useState('');
  const [leftLan, setLeftLan] = useState(translations?.leftLan);
  const [middleLan, setMiddleLan] = useState(translations?.middleLan);
  const [rightLan, setRightLan] = useState(translations?.rightLan);

  const [startData, setStartData] = useState();
  const [savedPartnumber, setSavedPartnumber] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [config, setConfig] = useState();
  const [taconData, setTaconData] = useState();
  const [cadURL, setCadURL] = useState('');
  const handleClose = () => {
    setOpenModal(false);
    setModalValue({});
  };
  const [price, setPrice] = useState();
  const [priceLeadTime, setPriceLeadTime] = useState();
  const [assemblyPrice, setAssemblyPrice] = useState();
  const [partNumberString, setPartNumberString] = useState();
  const [showLayout, setShowLayout] = useState(false);
  const [isLayoutLoaded, setIsLayoutLoaded] = useState(false);
  const [isManifoldSegmentStepEdited, setIsManifoldSegmentStepEdited] =
    useState(true);
  const [activeTab, setActiveTab] = useState();

  const [uniquePartIdentifier, setUniquePartIdentifier] = useState();
  const [isStationEdit, setIsStationEdit] = useState(false);
  const [editedStationMembers, setEditedStationMembers] = useState([]);
  const [editedManifoldSegmentforPrice, setEditedManifoldSegmentforPrice] =
    useState([]);
  const [manifoldPrices, setManifoldPrices] = useState([]);

  const [editedWorkStation, setEditedWorkStation] = useState([]);
  const [selectedKey, setSelectedkey] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [imageUrls, setImageUrls] = useState([]);
  const [lastCommitMember, setLastCommitMember] = useState();
  const [commits, setCommits] = useState();
  const [openLicenseModal, setOpenLicenseModal] = useState(false);
  const [isLicenseAccepted, setIsLicenseAccepted] = useState(false);
  const [currentSegmentName, setCurrentSegmentName] = useState('');
  const [apiError, setApiError] = useState(false);
  const [isCADValueChanged, setisCADValueChanged] = useState(false);

  let conModel, divId;

  const sethandleOpen = (
    heading,
    value,
    selectedKey,
    selectedValue,
    configState
  ) => {
    setModalValue({
      heading: heading,
      changed: value,
      value: selectedValue,
      key: selectedKey,
      configState: configState
    });
    handleOpen();
  };

  useEffect(() => {
    async function loadData() {
      if (divisionId == '' || langParameter != props.language) {
        setisLoading(true);
        setManifoldPrices([
          ...manifoldPrices,
          { segmentName: '', priceAmt: 0, currencyCode: '', currencySymbol: '' }
        ]);
        setEditedManifoldSegmentforPrice([
          ...editedManifoldSegmentforPrice,
          ''
        ]);
        let parameterPass =
          queryParams.get('controlandvaluestring') != null
            ? queryParams.get('controlandvaluestring')
            : queryParams.get('session') != null
            ? queryParams.get('session')
            : queryParams.get('Session');
        parameterPass =
          parameterPass != '' && parameterPass != null ? parameterPass : '';
        !parameterPass && setTimeout(() => navigate(redirectTo404()), 1000);

        let language = props.language?.toLowerCase();

        let response = await initializeConfigurator(parameterPass, language);
        if (response?.sessionData?.contentSyndication != null) {
          var configdata = getContentSyndicationData(
            response?.sessionData,
            response?.data,
            uniquePartIdentifier
          );
          console.log(configdata);
          window.parent.postMessage(
            {
              econfigdata: configdata
            },
            '*'
          );
        }
      }
    }
    loadData();
  }, [props.language]);

  useEffect(() => {
    async function loadPrice() {
      if (startData) {
        try {
          if (startData?.response?.status === 'OK') {
            setisLoading(true);
            await basePrice();
            setisLoading(false);
          }
        } catch (error) {
          console.log(error);
          setisLoading(false);
        }
      }
    }
    loadPrice();
  }, [startData]);

  const initializeConfigurator = async (sessionFromQuery, language) => {
    let sessionData = await getSessionData(sessionFromQuery);
    !sessionData?.seriesName &&
      setTimeout(() => navigate(redirectTo404()), 1000);

    if (!language) language = sessionData?.language?.toLowerCase() || 'en';

    let translations = await getTranslations(language);

    if (translations) {
      setLeftLan(translations?.leftLan ? translations?.leftLan : leftLan);
      setMiddleLan(
        translations?.middleLan ? translations?.middleLan : middleLan
      );
      setRightLan(translations?.rightLan ? translations?.rightLan : rightLan);
    }

    setSessionId(sessionFromQuery);
    setLangParameter(language);

    sessionData.language = language;
    //sessionData.countryId = props.countryId;
    if (sessionData.option != '100' && sessionData.option != '101') {
      //Option 100- Phconnect
      setShowLayout(true);
    }
    initialize(sessionData);
    setConfigModel(sessionData.configModel);
    conModel = sessionData.configModel;

    setSavedPartnumber(
      JSON.parse(localStorage.getItem(sessionData.configModel)) ?? []
    );

    let contactInfo = await getContactInfo(sessionData);
    setContactUs(contactInfo);

    let chatData = await getChat(sessionData);
    setConfig(chatData);

    let mLocation = await getManufacturingLocation(
      sessionData.manufacturingDivision,
      sessionData.configModel
    );
    setDivisionId(mLocation);
    divId = mLocation;

    sessionData.manufacturingLocation = mLocation;

    setSessionData(sessionData);

    let response = await startConfigurator(
      sessionData,
      sessionData.manufacturingLocation
    );

    if (!response) {
      setApiError(true);
    }

    handleStartData(response);

    if (sessionData.partNumber) {
      response = await loadSearchResult(
        sessionData.partNumber,
        sessionData,
        response
      );
      handleStartData(response);
    }

    if (sessionData.option == '97') {
      response = await configureForVE(sessionData, response);
      if (
        response.tactonModel.steps.filter(
          x => x.name.includes('manifold') && x.available == true
        ).length > 0
      ) {
        let uniquePartNumber = await getUniquePartIdentifierforManifold(
          response,
          sessionData
        );
        setUniquePartIdentifier(uniquePartNumber);
        handleIsCADValueChanged(true);
        sessionData.partNumber = uniquePartNumber;
        var sessionId = await postSessionData(sessionData);
        await create(
          response,
          sessionData,
          sessionId,
          uniquePartNumber,
          uniquePartNumber
        );
      }
      handleStartData(response);
    }

    handleStartData(response);
    response = await isProductPagePartSelection(sessionData, response);
    handleStartData(response);

    //let chatCountries = LiveChatCountries;

    // if (
    //   chatCountries?.CountryList?.filter(
    //     x => x.CountryID?.toLowerCase() == sessionData?.countryId?.toLowerCase()
    //   ).length <= 0
    // )
    salesForceChat.LoadSalesForceChat(sessionData, chatData?.chatSkillGroup);

    if (sessionData?.configModel?.toLowerCase() == 'pto')
      setOpenLicenseModal(true);

    return {
      data: response,
      sessionData: sessionData
    };
  };

  const configureForVE = async (sessionData, response) => {
    var manifoldCommits = sessionData.manifoldCommits;
    var manifoldStepName;
    var segmentStepName;
    var startModel = response.tactonModel;
    var toCommit = [];
    var manifoldSegmentCommits = [];
    var manifoldSegmentCommit = new Object();

    if (
      manifoldCommits &&
      manifoldCommits.length > 0 &&
      response.isManifoldProduct
    ) {
      manifoldStepName = startModel.steps.find(x =>
        x.name.includes('manifold')
      ).name;
      segmentStepName = startModel.steps.find(x =>
        x.name.includes('segment')
      ).name;
      for (var stepIndex = 0; stepIndex < manifoldCommits.length; stepIndex++) {
        if (manifoldCommits[stepIndex].segmentName.includes('manifold')) {
          manifoldSegmentCommit = new Object();
          manifoldSegmentCommit.segmentName = manifoldStepName;
          manifoldSegmentCommit.commits = manifoldCommits[stepIndex].commits;
          manifoldSegmentCommits.push(manifoldSegmentCommit);
        } else {
          toCommit = getCommitsForSegment(
            manifoldCommits[stepIndex].segmentName,
            manifoldCommits[stepIndex].commits,
            response
          );
          var segmentStep = manifoldSegmentCommits.find(x =>
            x.segmentName.includes('segment')
          );
          //get the commits for segments
          if (!segmentStep) {
            manifoldSegmentCommit = new Object();
            manifoldSegmentCommit.segmentName = segmentStepName;
            manifoldSegmentCommit.commits = toCommit;
            manifoldSegmentCommits.push(manifoldSegmentCommit);
          } else {
            segmentStep.commits.push(...toCommit);
          }
        }
      }

      let res = await fetchAllManifoldAssemblyStations(
        createRequest(
          {
            activeTab: 'manifold',
            commits: manifoldSegmentCommits,
            step: response.manifoldStep.name,
            commitConfigState: ''
          },
          response.configState
        )
      );

      if (sessionData.option == '100') {
        let priceResponse = await getPriceforAssemblyandSegment(
          res,
          manifoldPrices,
          sessionData
        );
        setManifoldPrices(priceResponse.manifoldPrices);
        setPriceLeadTime(priceResponse.priceLeadTime);
      }

      response = res ? res : response;
    } else {
      response = await batchCommitProductMember(
        createRequest(
          {
            commits: sessionData?.commits,
            isManifoldSegmentStepEdited: true
          },
          response.configState
        )
      );
    }
    return response;
  };
  const startConfigurator = async (sessionData, divisionId) => {
    let startRequest = {
      configModel: sessionData.configModel,
      divisionId: divisionId
    };

    let response = await start(startRequest);
    return response;
  };

  const onChangeCommit = async (key, configState, value, url) => {
    setisLoading(true);
    let stepName = getCurrentStepName(startData);

    let response = await Commit(
      createRequest({
        key: key,
        value: value,
        step: stepName,
        activeTab: startData?.isManifoldProduct ? activeTab : ''
      })
    );
    handleStartData(response);
    setisLoading(false);
    return response;
  };
  const onChangeReset = async (key, configState, value) => {
    setisLoading(true);
    let stepName = getCurrentStepName(startData);

    let response = await UnCommit(
      createRequest({
        key: key,
        step: stepName,
        activeTab: startData?.isManifoldProduct ? activeTab : ''
      })
    );
    handleStartData(response);
    setisLoading(false);
    return response;
  };

  const handleOnChange = async (
    itemName,
    configState,
    action,
    selectedVal,
    url,
    member,
    stepName,
    isSegment
  ) => {
    let response;
    if (action == 'commit') {
      setUniquePartIdentifier('');
      setSelectedkey(itemName);
      setSelectedValue(selectedVal);
      setLastCommitMember(member);
      handleIsCADValueChanged(true);
      if (startData.isManifoldProduct) {
        response = await onChangeCommitManifold(
          member,
          stepName,
          configState,
          itemName,
          selectedVal,
          isSegment
        );
      } else {
        response = await onChangeCommit(
          itemName,
          configState,
          selectedVal,
          url
        );
      }
      handleFacetInteractionDataLayer(response, member, selectedVal, true);
      if (sessionData.contentSyndication != null) {
        var configdata = getContentSyndicationData(
          sessionData,
          response,
          uniquePartIdentifier
        );
        console.log(configdata);
        window.parent.postMessage(
          {
            econfigdata: configdata
          },
          '*'
        );
      }
    } else if (action == 'reset') {
      setUniquePartIdentifier('');
      setSelectedkey(itemName);
      setSelectedValue(selectedVal);
      if (startData.isManifoldProduct) {
        response = await onChangeUnCommitManifold(
          itemName,
          selectedVal,
          configState
        );
      } else {
        response = await onChangeReset(itemName, configState, selectedVal);
      }
      handleFacetInteractionDataLayer(response, member, selectedVal, false);
      if (sessionData.contentSyndication != null) {
        var configdata = getContentSyndicationData(
          sessionData,
          response,
          uniquePartIdentifier
        );
        console.log(configdata);
        window.parent.postMessage(
          {
            econfigdata: configdata
          },
          '*'
        );
      }
    } else {
      setSelectedkey();
      setSelectedValue();
      setisLoading(true);
      initializeConfigurator(sessionId, langParameter);
    }
  };

  const onChangeCommitManifold = async (
    member,
    segmentName,
    configState,
    key,
    value,
    isSegment
  ) => {
    setisLoading(true);
    let response = startData;
    let uncommitSegment = false;

    if (!isSegment) {
      if (
        member?.properties &&
        member.properties['ph_series_selection'] == 'yes'
      )
        uncommitSegment = true;

      if (uncommitSegment) {
        var segmentRootGroup = response?.segmentStep.rootGroup.members.filter(
          x => x.name == segmentName
        )[0];
        var segmentCommits = currentSegmentcommitedUIMembers(segmentRootGroup);
        if (segmentCommits.length > 0) {
          handleDeleteSegmentEdited(segmentName);

          let res = await batchUncommit(
            createRequest(
              {
                step: activeTab,
                activeTab: activeTab,
                commits: segmentCommits.map(x => x.name)
              },
              configState
            )
          );
          response = res ? res : response;
          configState = response
            ? response?.tactonModel?.configState
            : configState;
        }
      }
    }
    response = await commitAssemblyManifold(
      createRequest({
        key: key,
        value: value,
        isManifoldSegmentStepEdited: isManifoldSegmentStepEdited,
        activeTab: activeTab,
        step: activeTab
      })
    );
    setIsManifoldSegmentStepEdited(true);
    if (isStationEdit) {
      let editedMember = assignEditedSegmentMember(
        key,
        '',
        segmentName,
        startData,
        editedStationMembers
      );
      setEditedStationMembers([...editedStationMembers, editedMember]);
    }

    if (
      !activeTab.includes('manifold') &&
      !response.response?.status !== 'OK'
    ) {
      if (segmentName && !isStationEdit) {
        var allActiveStations = allSegments(response);
        handleEditedManifoldSegmentforPrice(
          segmentName,
          allActiveStations,
          false
        );
      }
    }

    handleStartData(response);
    setisLoading(false);
    return response;
  };

  const onChangeUnCommitManifold = async (key, value, configState) => {
    setisLoading(true);

    let response = await unCommitAssemblyManifold(
      createRequest({
        key: key,
        isManifoldSegmentStepEdited: isManifoldSegmentStepEdited,
        step: activeTab,
        activeTab: activeTab
      })
    );

    handleIsManifoldSegmentStepEdited(true);

    handleStartData(response);

    setisLoading(false);
    return response;
  };

  const handleCurrentSegmentName = name => {
    setCurrentSegmentName(name);
  };

  const conflicts = () => {
    return startData?.response?.changed;
  };

  const handleAccept = async (value, key, configState) => {
    setisLoading(true);
    let stepName = getCurrentStepName(startData);

    if (startData.isManifoldProduct) {
      if (isStationEdit) {
        conflicts().forEach(x => {
          let editedMember = assignEditedSegmentMember(
            x.name,
            x.oldValue,
            currentSegmentName,
            startData,
            editedStationMembers
          );
          editedStationMembers.push(editedMember);
        });
        setEditedStationMembers(editedStationMembers);
      }
    }

    let response = await Accept(
      createRequest(
        {
          step: stepName,
          activeTab: startData?.isManifoldProduct ? activeTab : ''
        },
        configState
      )
    );
    handleStartData(response);
    handleFacetInteractionDataLayer(response, lastCommitMember, value, true);
    setisLoading(false);
    handleClose();
  };
  async function handleCopyToClipBoard(copyCodeVal, uniquePartNumber) {
    setisLoading(true);
    if (startData.isManifoldProduct) {
      sessionData.partNumber = copyCodeVal;
    } else if (startData.isNormalProduct) {
      sessionData.partNumber = getPartNumberString(startData);
    } else {
      sessionData.partNumber = startData?.infoGroup?.orderCodeComplete?.value;
    }

    copyToClipboardDataLayer(sessionData, getPartNumberString(startData));

    if (sessionData.contentSyndication != null) {
      var configdata = getContentSyndicationData(
        sessionData,
        startData,
        uniquePartNumber
      );
      console.log(configdata);

      window.parent.postMessage(
        {
          econfigdata: configdata
        },
        '*'
      );
    }

    let sessionId = await postSessionData(sessionData);

    await create(
      startData,
      sessionData,
      sessionId,
      sessionData.partNumber,
      uniquePartNumber
    );

    setisLoading(false);
  }

  const handlePartSubmit = async (value, submitType, name, isPartialLoad) => {
    setisLoading(true);
    let response;
    if (submitType == 'search') {
      if (!isPartialLoad) {
        let result = await find(value, configModel);
        if (result.result === 1) {
          partSearchDataLayer(sessionData, getPartNumberString(startData));
          response = await loadSearchResult(
            result.partNumber,
            sessionData,
            startData
          );
        } else {
          setisLoading(false);
          return result.result;
        }
      } else {
        partSearchDataLayer(sessionData, getPartNumberString(startData));
        response = await loadSearchResult(value, sessionData, startData);
      }
      if (sessionData.contentSyndication != null) {
        var configdata = getContentSyndicationData(
          sessionData,
          response,
          uniquePartIdentifier
        );
        console.log(configdata);
        window.parent.postMessage(
          {
            econfigdata: configdata
          },
          '*'
        );
      }
    } else if (submitType == 'share') {
      await shareConfiguration(value);
      shareConfigurationDataLayer(sessionData, getPartNumberString(startData));
    } else if (submitType == 'save') {
      saveBomData(value);
      saveConfigurationDataLayer(
        sessionData,
        getPartNumberString(startData),
        value
      );
    } else if (submitType == 'remove') {
      removeStoredData(value);
      deleteConfigurationDataLayer(
        sessionData,
        getPartNumberString(startData),
        name
      );
    } else if (submitType == 'load') {
      response = await loadSearchResult(value, sessionData, startData);
      loadConfigurationDataLayer(
        sessionData,
        getPartNumberString(startData),
        name
      );

      if (sessionData.contentSyndication != null) {
        var configdata = getContentSyndicationData(
          sessionData,
          response,
          uniquePartIdentifier
        );
        console.log(configdata);
        window.parent.postMessage(
          {
            econfigdata: configdata
          },
          '*'
        );
      }
    }
    handleStartData(response);
    setisLoading(false);
  };

  const loadManifoldConfigurator = async (
    partNumber,
    sessionData,
    response
  ) => {
    var uniqueIdentifierModel = await getConfigStateByPart(partNumber);
    setIsManifoldSegmentStepEdited(false);
    handleIsCADValueChanged(true);

    response = await fetchAllManifoldAssemblyStations(
      createRequest(
        {
          activeTab: activeTab ? activeTab : response?.manifoldStep?.name,
          step: response.manifoldStep.name,
          commits: null,
          commitConfigState: uniqueIdentifierModel.configState
        },
        response.configState
      )
    );
    if (sessionData.option == '100' || sessionData.option == '101') {
      let priceResponse = await getPriceforAssemblyandSegment(
        response,
        manifoldPrices,
        sessionData
      );
      setManifoldPrices(priceResponse.manifoldPrices);
      setPriceLeadTime(priceResponse.priceLeadTime);
    }

    setUniquePartIdentifier(partNumber);
    return response;
    setisLoading(false);
  };

  const loadSearchResult = async (value, sessionData, response) => {
    if (response.isManifoldProduct) {
      response = await loadManifoldConfigurator(value, sessionData, response);
    } else {
      var uniqueIdentifierModel = await getConfigStateByPartNumber(value);
      if (uniqueIdentifierModel) {
        setUniquePartIdentifier(uniqueIdentifierModel.uniquePartIdentifier);
        response = await configureFromConfigState(
          uniqueIdentifierModel,
          sessionData,
          response
        );
      } else {
        var bomModel = await getByPart(value);
        if (bomModel) {
          response = await configureFromBom(bomModel, sessionData, response);
        }
      }
    }
    setisLoading(false);
    return response;
  };

  const saveBomData = async title => {
    setisLoading(true);

    if (startData.isManifoldProduct) {
      sessionData.partNumber = uniquePartIdentifier;
    } else if (startData.isNormalProduct) {
      sessionData.partNumber = getPartNumberString(startData);
    } else {
      sessionData.partNumber = startData?.infoGroup?.orderCodeComplete?.value;
    }

    let cookieData = JSON.parse(
      localStorage.getItem(sessionData.configModel) ?? '[]'
    );

    if (cookieData.filter(x => x.title == title).length <= 0) {
      cookieData.push({
        title: `${title}`,
        partNumber: sessionData.partNumber ? sessionData.partNumber : '11111111'
      });
      localStorage.setItem(sessionData.configModel, JSON.stringify(cookieData));
    }

    setSavedPartnumber(cookieData);

    setisLoading(false);
  };

  const removeStoredData = value => {
    let cookieData = JSON.parse(
      localStorage.getItem(sessionData.configModel) ?? '[]'
    );
    let cookies = [];
    cookieData.map(item => {
      if (item.partNumber != value) {
        cookies.push({
          title: item.title,
          partNumber: item.partNumber
        });
      }
    });

    localStorage.setItem(sessionData?.configModel, JSON.stringify(cookies));
    setSavedPartnumber(cookies);
    setisLoading(false);
  };

  const getDivisionMembersFromStep = () => {
    var results = [];
    var step = getStep(startData);
    var rootMembers = step.rootGroup.members.filter(x =>
      x.name.includes('division_group')
    );
    if (rootMembers.length == 0)
      rootMembers = step.rootGroup.members.filter(x =>
        x.name.includes('ui_group')
      );
    if (rootMembers.length == 0) rootMembers = step.rootGroup.members;
    for (let member of rootMembers) {
      results = results.concat(getMembersFromRootMember(member));
    }

    return results.map(x => {
      return {
        name: x.description,
        value: x.value,
        valueDescription: x.valueDescription,
        domainName: x.domain.name,
        componentName: x.name,
        committed: x.committed,
        hidden: x.properties.hidden
      };
    });
  };

  const getMembersFromRootMember = rootGroupMember => {
    let results = [];
    let description = '';
    let options = { firstMemberOnly: false, findByName: false };
    for (let member of rootGroupMember.members) {
      var memberResults = getMembersFromMembers(member, description, options);
      if (
        memberResults.length > 1 &&
        options &&
        options.firstMemberOnly == true
      )
        memberResults = [memberResults[0]];
      //memberResults[0].NodeName = this.NodeName;
      results = results.concat(memberResults);
    }
    return results;
  };

  //Repeated here and also in editModal
  const getMembersFromMembers = member => {
    var results = [];
    let options = { firstMemberOnly: false, findByName: false };
    let description = '';
    if (!member.isGroup) {
      if (!description) return [member];

      if (options.findByName == true && description != member.name) return [];

      if (options.findByName !== true && description != member.description)
        return [];

      return [member];
    }

    for (let child of member.members) {
      if (child.isGroup) {
        results = results.concat(
          getMembersFromMembers(child, description, options)
        );
        continue;
      }

      if (
        !description ||
        (options.findByName == true && child.name == description) ||
        (options.findByName !== true && child.description == description)
      ) {
        results.push(child);
        continue;
      }
    }
    return results;
  };

  const passCadUrlToParent = cadURL => {
    setCadURL(cadURL);
  };

  const currentStep = () => {
    return startData.tactonModel.steps.filter(x => x.current);
  };

  const basePrice = async () => {
    var step = getStep(startData);
    if (step != null) {
      if (sessionData?.option == '100' || sessionData?.option == '101') {
        if (startData.isManifoldProduct) {
          let currentStepData = currentStep();
          if (currentStepData) {
            if (currentStepData[0].name.includes('segment')) {
              await handleManifoldPrices(editedManifoldSegmentforPrice);
            } else {
              let response = await getPriceforAssemblyandSegment(
                startData,
                manifoldPrices,
                sessionData
              );
              setManifoldPrices(response.manifoldPrices);
              setPriceLeadTime(response.priceLeadTime);
            }
          }
        } else {
          setPriceLeadTime(
            await getPricefromLegacyPriceSheets(sessionData, startData)
          );
        }
        setAssemblyPrice(null);
      } else if (
        sessionData?.cartType == CartType.Shop &&
        sessionData.configModel != 'GlobalCore'
      ) {
        setAssemblyPrice(
          await getHoseAssemblyPrice(getDivisionMembersFromStep(step))
        );
        setPriceLeadTime(null);
      }
    }
  };

  const handleManifoldPrices = async editedManifoldSegmentforPrice => {
    let res = await getTotalPriceforSegmentandAssembly(
      editedManifoldSegmentforPrice,
      startData,
      manifoldPrices,
      sessionData
    );
    setManifoldPrices(res.manifoldPrices);
    setPriceLeadTime(res.priceLeadTime);
    setEditedManifoldSegmentforPrice([]);
  };

  const handleRemovePrice = async (segement, response) => {
    let res = await removePriceforSegment(
      segement,
      response,
      manifoldPrices,
      sessionData
    );
    setManifoldPrices(res.manifoldPrices);
    setPriceLeadTime(res.priceLeadTime);
  };

  const isHeader = () => {
    if (sessionData?.contentSyndication == null) {
      return true;
    }
    return sessionData?.contentSyndication.header_visible;
  };

  const isFooter = () => {
    if (sessionData?.contentSyndication == null) {
      return true;
    }
    return sessionData?.contentSyndication.footer_visible;
  };

  const redirectTo404 = () => {
    window.location.href = 'https://www.parker.com/us/en/error-pages/404.html';
  };

  const handleIsManifoldSegmentStepEdited = value => {
    setIsManifoldSegmentStepEdited(value);
  };

  const handleActiveTab = value => {
    setActiveTab(value);
  };

  const handleStartData = data => {
    setStartData(data ? data : startData);
  };

  const handleIsStationEdit = isStationEdit => {
    setIsStationEdit(isStationEdit);
  };

  const handleEditeStationMembers = () => {
    setEditedStationMembers([]);
  };

  const handleUniquePartNumber = value => {
    setUniquePartIdentifier(value);
  };

  const handleEditedManifoldSegmentforPrice = (
    segmentName,
    currentActiveStations,
    isAdd
  ) => {
    setEditedManifoldSegmentforPrice(prevState => {
      if (isAdd) {
        if (!prevState.includes(segmentName))
          return [...prevState, segmentName];
        else return prevState;
      } else {
        if (
          !prevState.includes(segmentName) &&
          !segmentName.includes('manifold')
        )
          return [...prevState, segmentName];
        else return prevState;
      }
    });

    let previousActiveWorkStation = allSegments(startData);
    if (currentActiveStations.length > previousActiveWorkStation.length) {
      setEditedManifoldSegmentforPrice(prevState => {
        if (!prevState.includes('manifold')) return [...prevState, 'manifold'];
        else return prevState;
      });

      for (
        var i = previousActiveWorkStation.length;
        i < currentActiveStations.length;
        i++
      ) {
        setEditedManifoldSegmentforPrice(prevState => {
          if (!prevState.includes(currentActiveStations[i].name))
            return [...prevState, currentActiveStations[i].name];
          else return prevState;
        });
      }
    }
  };

  const handleEditedWorkStation = (name, value, isClear) => {
    if (!isClear) {
      setEditedWorkStation(prevState => [
        ...prevState,
        { key: name, value: value }
      ]);
    } else setEditedWorkStation([]);
  };

  const handleDeleteSegmentEdited = name => {
    var array = editedWorkStation;
    var index = array.findIndex(x => x.key == name);
    if (index !== -1) {
      array.splice(index, 1);
      setEditedWorkStation(array);
    }
  };

  useEffect(() => {
    if (startData?.response?.status === 'RESOLVABLE') {
      sethandleOpen(
        '',
        startData?.response?.changed,
        selectedKey,
        selectedValue,
        startData?.configState
      );
    }
    setImageUrls(startData?.imageControlURLs);
  }, [startData]);

  useEffect(() => {
    if (apiError) {
      setisLoading(false);
    }
  }, [apiError]);

  const handleFacetInteractionDataLayer = (
    response,
    member,
    value,
    isCommit
  ) => {
    if (response?.response?.status !== 'RESOLVABLE') {
      let stepMembers = getStepMembers(response);

      if (isCommit) {
        facetInteractionDataLayer(
          member,
          value,
          stepMembers,
          sessionData,
          isCommit
        );

        let index = getIndex(stepMembers, member);
        if (index > -1)
          setCommits(
            SetCommitsName(commits, member.description, index, response)
          );
      } else {
        setCommits(RemoveCommitsName(commits, member.description));
        facetInteractionDataLayer(
          member,
          value,
          stepMembers,
          sessionData,
          isCommit
        );
      }
    }
  };

  const shareConfiguration = async email => {
    var uniqueCode = uniqueCodeTemplate(startData);
    let uniquePartNumber;
    if (uniqueCode != '') {
      uniquePartNumber = await getUniquePartIdentifierforManifold(
        startData,
        sessionData
      );
      if (startData?.isManifoldProduct) {
        sessionData.partNumber = uniquePartNumber;
      } else {
        sessionData.partNumber = getPartNumberString(startData);
      }
      setUniquePartIdentifier(uniquePartNumber);
    } else if (!startData?.isNormalProduct) {
      sessionData.partNumber = startData?.infoGroup?.orderCodeComplete?.value;
    } else {
      sessionData.partNumber = getPartNumberString(startData);
    }

    let sessionId = await postSessionData(sessionData);

    await create(
      startData,
      sessionData,
      sessionId,
      sessionData.partNumber,
      uniquePartNumber
    );

    await shareConfigurationInfo(email, sessionId);
  };

  const handleSetCommits = commitsName => {
    setCommits(commitsName);
  };

  const handleCloseLinceseModal = () => {
    setOpenLicenseModal(false);
  };

  const isMobile = () => {
    if (window.innerWidth < 768) return true;
    else return false;
  };

  const isProductPagePartSelection = async (sessionData, response) => {
    //pre select configurator
    var ProductPagePartSelection = await getProductPagePartSelection(
      sessionData.seriesName
    );
    for (let member of ProductPagePartSelection) {
      var PreCommitMember = response?.uiGroup.members.filter(
        x => x.name == member.commitKey
      );
      if (PreCommitMember && PreCommitMember.length > 0) {
        let stepName = getCurrentStepName(response);
        response = await Commit(
          createRequest(
            {
              key: member.commitKey,
              value: member.commitValue,
              step: stepName,
              activeTab: response?.isManifoldProduct ? activeTab : ''
            },
            response.configState
          )
        );
      }
    }
    return response;
  };

  const getCurrentStepName = response => {
    if (response.isDynamicStackableProduct) {
      return 'product_selection';
    } else {
      return response.tactonModel.steps.filter(x => x.current)[0]?.name;
    }
  };

  const handleIsCADValueChanged = isCADValueChanged => {
    setisCADValueChanged(isCADValueChanged);
  };

  const createRequest = (data, configState) => {
    let requestData = {
      divisionId: divisionId ? divisionId : divId,
      configState: configState ? configState : startData.configState,
      configModel: configModel ? configModel : conModel,
      ...data
    };
    return requestData;
  };

  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="https://parker.com/">
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href={sessionData?.breadCrumbUrl0}
    >
      {sessionData?.breadCrumbText0}
    </Link>,
    <Link
      underline="hover"
      key="3"
      color="inherit"
      href={sessionData?.breadCrumbUrl1}
    >
      {sessionData?.breadCrumbText1}
    </Link>,
    <Link
      underline="hover"
      key="4"
      color="inherit"
      href={sessionData?.breadCrumbUrl2}
    >
      {sessionData?.breadCrumbText2}
    </Link>,
    <Typography key="5" color="text.primary" className="bread-crumb-seriesname">
      {sessionData?.seriesName}
    </Typography>
  ];

  const LayoutLoaded = () => {
    if (startData || apiError) {
      if (startData?.configState || apiError) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleLicenseAccept = () => {
    setIsLicenseAccepted(true);
  };

  return (
    <>
      <div className={!LayoutLoaded() ? 'd-none' : 'd-block'}>
        <Loader show={isLoading} />
        {showLayout && isHeader() && LayoutLoaded() && (
          <Header sessionData={sessionData} />
        )}

        <div className="app-content">
          <Grid container className="bread-crumb-row">
            <Grid item xs={12} md={12} lg={9}>
              {sessionData?.breadCrumbText0 &&
              sessionData?.breadCrumbText0?.length > 0 ? (
                <Breadcrumbs
                  className="bread-crumb"
                  separator={<ArrowRightIcon className="bread-crumb-arrow" />}
                >
                  {breadcrumbs}
                </Breadcrumbs>
              ) : (
                <> </>
              )}
            </Grid>
            <Grid item xs={12} md={12} lg={3}>
              <GeneralCAST />
            </Grid>
          </Grid>
          <Grid container>
            <ModalAccept
              open={openModal}
              handleOpen={handleOpen}
              handleClose={handleClose}
              modalValue={modalValue}
              handleAccept={handleAccept}
            />
            <LicenseModal
              open={openLicenseModal && !isLicenseAccepted}
              handleClose={handleCloseLinceseModal}
              handleLicenseAccept={handleLicenseAccept}
            />

            <Grid item className="left-wrapper">
              <LeftSection
                dataItems={startData}
                handleOnChange={handleOnChange}
                sessionDataItems={sessionData}
                lang={leftLan}
                taconData={taconData}
                isLoading={e => setisLoading(e)}
                partNumberString={e => setPartNumberString(e)}
                handleIsManifoldSegmentStepEdited={
                  handleIsManifoldSegmentStepEdited
                }
                handleActiveTab={handleActiveTab}
                handleStartData={handleStartData}
                isManifoldSegmentStepEdited={isManifoldSegmentStepEdited}
                activeTab={activeTab}
                isStationEdit={isStationEdit}
                handleIsStationEdit={handleIsStationEdit}
                editedStationMembers={editedStationMembers}
                handleEditeStationMembers={handleEditeStationMembers}
                editedManifoldSegmentforPrice={editedManifoldSegmentforPrice}
                handleEditedManifoldSegmentforPrice={
                  handleEditedManifoldSegmentforPrice
                }
                handleManifoldPrices={handleManifoldPrices}
                handleRemovePrice={handleRemovePrice}
                editedWorkStation={editedWorkStation}
                handleEditedWorkStation={handleEditedWorkStation}
                handleDeleteSegmentEdited={handleDeleteSegmentEdited}
                imageUrls={imageUrls}
                handleSetCommits={handleSetCommits}
                commits={commits}
                handleCurrentSegmentName={handleCurrentSegmentName}
                handleIsCADValueChanged={handleIsCADValueChanged}
              />

              <ConfigOptionFeedback />
            </Grid>

            <Grid item className="middle-wrapper">
              {sessionData && (
                <MiddleSection
                  contactus={contactUs}
                  dataItems={startData}
                  sessionDataItems={sessionData}
                  handleCopyToClipBoard={handleCopyToClipBoard}
                  handleSearchPartNumber={handlePartSubmit}
                  savedPartNumber={savedPartnumber}
                  lang={middleLan}
                  rightLang={rightLan}
                  isLoading={e => setisLoading(e)}
                  partNumberString={partNumberString}
                  passCadUrlToParent={passCadUrlToParent}
                  uniquePartIdentifier={uniquePartIdentifier}
                  handleUniquePartNumber={handleUniquePartNumber}
                  priceLeadTime={priceLeadTime}
                  hoseAssemblyPrice={assemblyPrice}
                  activeTab={activeTab}
                  handleSetCommits={handleSetCommits}
                  commits={commits}
                  handleIsCADValueChanged={handleIsCADValueChanged}
                  isCADValueChanged={isCADValueChanged}
                />
              )}
            </Grid>

            {!isMobile() && (
              <Grid item className="right-wrapper">
                <RightSection
                  contactus={contactUs}
                  dataItems={startData}
                  sessionDataItems={sessionData}
                  lang={rightLan}
                  isLoading={e => setisLoading(e)}
                  chk={1}
                  priceLeadTime={priceLeadTime}
                  hoseAssemblyPrice={assemblyPrice}
                  handleUniquePartNumber={handleUniquePartNumber}
                  uniquePartIdentifier={uniquePartIdentifier}
                  activeTab={activeTab}
                  config={config}
                />
              </Grid>
            )}
          </Grid>
        </div>

        {showLayout && isFooter() && LayoutLoaded() && (
          <Footer sessionData={sessionData} />
        )}
      </div>

      {!LayoutLoaded() && (
        <div className="align-center page-loader">
          <h1 className="page-loader-header">Starting Configurator</h1>

          <CircularProgress className="spinner" />
        </div>
      )}
    </>
  );
};
export default MainWrapper;
